import { GENERATED_PLAYER_ROSTERS } from './playerRosters.generated'

function normalizeTeamName(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('es')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
}

const ROSTERS_BY_NORMALIZED_NAME = new Map(
  Object.entries(GENERATED_PLAYER_ROSTERS).map(([team, names]) => [normalizeTeamName(team), names] as const),
)

/** Devuelve la plantilla real asociada al nombre de club o selección usado por el juego. */
export function getPlayerRoster(teamName: string): readonly string[] | undefined {
  return ROSTERS_BY_NORMALIZED_NAME.get(normalizeTeamName(teamName))
}
